export default __webpack_public_path__ + "static/media/HUB_Certificate_Updated_2023.pdf";